<!-- Order: Copy, then Speaker (share is separate component) -->
<div class="toolbar">

  <!-- Copy -->
  <button type="button"
          *ngIf="showCopy"
          class="btn-value-components t-bottom t-no-arrow" [class.copy-icon-not-agent]="!isAgent"
          [attr.aria-label]="'COPY_BUTTON_TEXT' | translate"
          [disabled]="disabled"
          (click)="copyToClipboard()">
    <span *ngIf="isAnswerCopied" class="tick-icon"><i class="fas fa-check"></i></span>
    <ng-container *ngIf="!isAnswerCopied">
      <img class="copy-icon icon-default" src="assets/icons/icon-copy-1.svg" alt="Copy" />
    </ng-container>
  </button>
  <!-- Speaker (audio) -->
  <button type="button"
          *ngIf="showAudio"
          class=" btn-value-components t-bottom t-no-arrow"
          [attr.aria-label]="'SPEAK_RESPONSE_BUTTON_TOOLTIP' | translate"
          [disabled]="disabled"
          (click)="speakResponse()">
    <ng-container *ngIf="!chatdata?.isSpeaking">
      <img src="assets/icons/icon-listen-1.svg" alt="Speak" class="voice t-bottom t-no-arrow icon-default" />
    </ng-container>
    <img *ngIf="chatdata?.isSpeaking && chatdata?.isPaused" src="assets/icons/icon-listen.svg" alt="Resume" class="voice voice-resume t-bottom t-no-arrow" />
    <img *ngIf="chatdata?.isSpeaking && !chatdata?.isPaused" src="assets/icons/pause-icon-active.svg" width="18" alt="Pause" class="voice voice-pause t-bottom t-no-arrow" />
  </button>
</div>
